import { render, staticRenderFns } from "./WagonLoad.vue?vue&type=template&id=5e5af287"
import script from "./wagonLoad.ts?vue&type=script&lang=js&external"
export * from "./wagonLoad.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports